import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/ai-agents/field-ai-agent-response']['GET'];
type Input = ThisApi['query'];

const getAiAgentResponse = async ({ fieldKey, questionnaireId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/ai-agents/field-ai-agent-response');
  const data = await formsBackendClient.get(path, {
    params: { fieldKey, questionnaireId},
  });
  return data.data;
};

export default getAiAgentResponse;